module.exports = __webpack_public_path__ + "media/images/icons/line_chart-e40c27deda4a9f3d39d80353b55b922b.svg";